import { render, staticRenderFns } from "./agriculturalInfo.vue?vue&type=template&id=2e26c2a0&scoped=true"
import script from "./agriculturalInfo.vue?vue&type=script&lang=js"
export * from "./agriculturalInfo.vue?vue&type=script&lang=js"
import style0 from "./agriculturalInfo.vue?vue&type=style&index=0&id=2e26c2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26c2a0",
  null
  
)

export default component.exports